




















import Vue, { PropOptions } from 'vue';
import util from '@/components/util';

export default Vue.extend({
  name: 'UserAddSpModal',
  components: { ...util},
  data() {
    return {};
  },
  methods: {
    onClickClose() {
      this.$emit('close');
    },
    onClickAddUser() {
      this.$emit('addUser');
    },
    onClickAddDepartment() {
      this.$emit('addDepartment');
    },
  },
});
